(function () {
  function normalizeIds(productId, variantId) {
    if (productId == null || variantId == null) return null;
    return { productId: String(productId), variantId: String(variantId) };
  }

  function getBisIdsFromEl(el) {
    var btn =
      el &&
      el.closest &&
      el.closest('.klaviyo-bis-trigger, [klaviyo-bis-trigger], .klaviyo-bis-trigger-button');
    if (!btn) return null;

    var pid = btn.getAttribute('data-product-id');
    var vid = btn.getAttribute('data-variant-id') || btn.getAttribute('data-variantid');
    return normalizeIds(pid, vid);
  }

  function wrapKlaviyoBis() {
    var k = window.klaviyo;
    if (!k || typeof k.bis !== 'function') return;

    if (k.bis.__tgWrapped) return;

    var orig = k.bis;

    function wrapped() {
      try {
        // Convert: bis('open', productId, variantId, cb) -> bis('open', {productId, variantId}, cb)
        if (
          arguments.length >= 3 &&
          arguments[0] === 'open' &&
          (typeof arguments[1] === 'string' || typeof arguments[1] === 'number') &&
          (typeof arguments[2] === 'string' || typeof arguments[2] === 'number')
        ) {
          var ids = normalizeIds(arguments[1], arguments[2]);
          var cb = arguments[3];
          return orig.call(this, 'open', ids, cb);
        }

        // Ensure object ids are strings
        if (arguments.length >= 2 && arguments[0] === 'open' && arguments[1] && typeof arguments[1] === 'object') {
          if ('productId' in arguments[1]) arguments[1].productId = String(arguments[1].productId);
          if ('variantId' in arguments[1]) arguments[1].variantId = String(arguments[1].variantId);
        }
      } catch (e) {}

      return orig.apply(this, arguments);
    }

    wrapped.__tgWrapped = true;
    k.bis = wrapped;
    k.bis.__tgWrapped = true;
  }

  function openBis(ids) {
    var k = window.klaviyo;
    if (!k) return false;

    wrapKlaviyoBis();

    // Preferred form
    if (typeof k.bis === 'function') {
      try {
        k.bis('open', { productId: ids.productId, variantId: ids.variantId });
        return true;
      } catch (e) {}
    }

    // Legacy fallback
    if (k.BIS && typeof k.BIS.open === 'function') {
      try {
        k.BIS.open(ids.productId, ids.variantId);
        return true;
      } catch (e) {}
    }

    return false;
  }

  // Run wrapper early and again after load
  wrapKlaviyoBis();
  document.addEventListener('DOMContentLoaded', wrapKlaviyoBis);

  // Capture click blocker
  document.addEventListener(
    'click',
    function (e) {
      var ids = getBisIdsFromEl(e.target);
      if (!ids) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      openBis(ids);
    },
    true
  );

  // Capture submit blocker
  document.addEventListener(
    'submit',
    function (e) {
      var ids = getBisIdsFromEl(document.activeElement);
      if (!ids) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      openBis(ids);
    },
    true
  );
})();